import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, of, takeUntil } from 'rxjs';
import { clearAllState, startTourIfUnseen } from '../../../core/store/actions/app.actions';
import { TourType } from '../../../tours/data/tour-config';
import { patientSwitchInitiated } from '../../../user/store/actions/user.actions';
import { selectPatientId } from '../../../user/store/selectors/user.selectors';
import { MedicalRecordNotificationsService } from '../../service/medical-record-notifications.service';
import {
  getMedicalRecordNotifications,
  getMedicalRecordNotificationsFailure,
  getMedicalRecordNotificationsSuccess,
} from '../actions/medical-record.actions';

@Injectable()
export class MedicalRecordEffects {
  private actions$ = inject(Actions);
  private store = inject(Store);
  private medicalRecordNotificationsService = inject(MedicalRecordNotificationsService);
  private readonly cancelRequest$ = this.actions$.pipe(ofType(patientSwitchInitiated, clearAllState));

  startMedicalRecordTourIfUnseen$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(getMedicalRecordNotificationsSuccess),
      map(() => {
        return startTourIfUnseen({ tourType: TourType.MedicalRecord });
      })
    );
  });

  getMedicalRecordNotifications$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(getMedicalRecordNotifications),
      concatLatestFrom(() => [this.store.select(selectPatientId)]),
      mergeMap(([, patientId]) => {
        return this.medicalRecordNotificationsService.getMedicalRecordNotifications(patientId).pipe(
          takeUntil(this.cancelRequest$),
          map(notifications => getMedicalRecordNotificationsSuccess({ notifications })),
          catchError(err => of(getMedicalRecordNotificationsFailure({ error: err.error?.errors })))
        );
      })
    );
  });
}
